import React from 'react';
import { render } from 'react-dom';
import 'isomorphic-fetch'; // Must be included before AppWrapper
import 'url-search-params-polyfill'; // Must be included before AppWrapper
import './utils/yupSetLocaleGlobal'; // Must be included before AppWrapper
import AppWrapper from './AppWrapper';
import './index.less';
render(React.createElement(AppWrapper, null), document.getElementById('gpf-fkl-app'));
